<template>
  <div>
    <iframe :src="orderLink" frameborder="0" width="100%" :height="height"></iframe>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      service: this.$route.params.service,
      height: 300,
    };
  },
  props: ['orderLink', 'webHeight'],
  mounted() {
    this.height = (this.service === 'FB') ? this.webHeight * 0.58 : this.webHeight * 0.66;
  },
  methods: {
  }
}
</script>

<style scoped>
  #card {
    width: 100%;
    height: 950px;
    max-width: 550px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 5px;
  }
  .web {
    text-decoration: none;
    color: black;
    transition: 0.2s;
  }
</style>